import './App.css';
import Body from './Body';
import Nav from './Nav';

function App() {
  return (
    <div className="App">
      <Nav />
      <Body />
    </div>
  );
}

export default App;
